import Papa from 'papaparse';

export function parseTargetInput<T>(input: string) {
  const result = Papa.parse<T>(input, { skipEmptyLines: true, transform: value => value.trim() });
  return result;
}
